import { RequestECatalogItem } from "./request-e-catalog-response";

interface ECatalogTableItem extends RequestECatalogItem {
    inputName: string;
}

const row = ({
    number,
    name,
    eCatalogAvailable,
    location,
    isFav,
    toggleFavUrl,
    inputName,
}: ECatalogTableItem): string => {
    return `
        <tr>
            <td>${
                eCatalogAvailable
                    ? `<ux-checkbox name="${inputName}" no-label value="${number}" />`
                    : `<ux-checkbox name="${inputName}" no-label disabled />`
            }</td>
            <td><ux-toggle-button
                sync-id="${number}"
                icon-on="fav-filled"
                icon-off="fav"
                toggle-url="${toggleFavUrl}"
                ${isFav ? "on" : ""}
            ></ux-toggle-button></td>
            <td>${name}</td>
            <td>${number}</td>
            <td>${location}</td>
        </tr>
    `;
};

export default row;
